document.addEventListener("DOMContentLoaded", () => {

  const search = document.getElementById("recipe-search");
  const veg = document.getElementById("filter-veg");
  const nonVeg = document.getElementById("filter-nonveg");
  const product = document.getElementById("recipe-product-filter");

  const cards = document.querySelectorAll(".recipe-card");

  const grid = document.getElementById("recipe-grid");
  const emptyState = document.getElementById("recipe-empty");

  function filterRecipes() {

    const searchText = search.value.trim().toLowerCase();

    const vegChecked = veg.checked;
    const nonVegChecked = nonVeg.checked;

    const selectedProduct = product.value.trim().toLowerCase();

    let visibleCount = 0;

    cards.forEach(card => {

      const title = (card.dataset.title || "").toLowerCase();

      const type = (card.dataset.type || "").toLowerCase();

      const products = (card.dataset.products || "")
        .split("|||TMM|||")
        .map(p => p.trim().toLowerCase());

      let visible = true;

      /* Search */

      if (searchText && !title.includes(searchText)) {
        visible = false;
      }

      /* Vegetarian */

      if (vegChecked && type !== "vegetarian") {
        visible = false;
      }

      /* Non Vegetarian */

      if (nonVegChecked && type !== "non-vegetarian") {
        visible = false;
      }

      /* Product */

      if (selectedProduct && !products.includes(selectedProduct)) {
        visible = false;
      }

      card.style.display = visible ? "" : "none";

      if (visible) {
        visibleCount++;
      }

    });

    if (visibleCount === 0) {

      grid.style.display = "none";
      emptyState.style.display = "flex";

    } else {

      grid.style.display = "grid";
      emptyState.style.display = "none";

    }

  }

  search.addEventListener("input", filterRecipes);
  veg.addEventListener("change", filterRecipes);
  nonVeg.addEventListener("change", filterRecipes);
  product.addEventListener("change", filterRecipes);

  /* Initialise on page load */

  filterRecipes();

});